var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-view"},[_c('edp-header',{staticClass:"bf",attrs:{"headerLeftWord":_vm.$t('member.360Header')}}),(_vm.sessionId)?_c('iframe',{staticClass:"web-wrap",attrs:{"src":_vm.urls}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }